import { render, staticRenderFns } from "./StellarCollectView.vue?vue&type=template&id=2302f380&"
import script from "./StellarCollectView.vue?vue&type=script&lang=js&"
export * from "./StellarCollectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports